import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgGridColumnType, AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-community/core'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { Nullable } from '@/shared/types/app.types'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDynamicObject, StatisticalAnalysisIncidentTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { store } from '@/store/store'
import { incidentsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.service'
import { StatisticalAnalysisIncidentsStatisticsDossierBaseRequest, StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTable, StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent, StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.dto'
import { chain, isNil } from 'lodash'
import { StatisticalAnalysisIncidentsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/incidents-dossier/incidents-dossier.model'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { parseGroupingParams } from '@/modules/statistical-analysis-module/shared/helpers/helpers'

export class StatisticalAnalysisHandlerDatasourceIncidentsDossierDetailList extends StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent> {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>
    protected row: StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>, row: StatisticalAnalysisDossiersDatasourceResponsesTypes) {
        super()
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
        this.row = row as StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent
    }

    public getGridColumns(): (ColDef | ExportedColDef)[] {
        return [
            { type: AgGridColumnType.CUSTOM_CHECKBOX },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.incidentNumber'),
                field: 'incidentLabel',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.DATETIME,
                headerName: i18n.tc('statisticalAnalysis.grids.incidentDate'),
                field: 'incidentDate',
                exportType: AgGridExportType.DATETIME,
                minWidth: 120,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.DATETIME,
                headerName: i18n.tc('statisticalAnalysis.grids.openingDate'),
                field: 'openingDate',
                exportType: AgGridExportType.DATETIME,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.DATETIME,
                headerName: i18n.tc('statisticalAnalysis.grids.closingDate'),
                field: 'closingDate',
                exportType: AgGridExportType.DATETIME,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.openedBy'),
                field: 'openedBy.fullName',
                exportType: AgGridExportType.TEXT,
                minWidth: 120,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.closedBy'),
                field: 'closedBy.fullName',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.affectedEntity'),
                field: 'coreEntity.translatedName',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.affectedEntityId'),
                field: 'entityExternalId',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.incidentOrigin'),
                field: 'incidentOrigin.description',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.incidentType'),
                field: 'incidentType.description',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.severity'),
                field: 'incidentSeverity.description',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.notifiedPetitioner'),
                field: 'notifiedPersonnel',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false,
                autoHeight: true,
                cellRenderer: params => {
                    let value = ''
                    if (params.data && params?.data?.notifiedPersonnel) {
                        let notifiedPersonnel
                        for (notifiedPersonnel of params?.data?.notifiedPersonnel) {
                            value += notifiedPersonnel?.fullName + '<br/>'
                        }
                    }
                    return value
                }
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.notifiedResponsabilities'),
                field: 'notifiedResponsibilities',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false,
                autoHeight: true,
                cellRenderer: params => {
                    let value = ''
                    if (params.data && params?.data?.notifiedPersonnel) {
                        let notifiedResponsibilities
                        for (notifiedResponsibilities of params?.data?.notifiedResponsibilities) {
                            value += notifiedResponsibilities?.translatedName + '<br/>'
                        }
                    }
                    return value
                }
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.casePhase'),
                field: 'phase.name',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            },
            {
                type: AgGridColumnType.TEXT,
                headerName: i18n.tc('statisticalAnalysis.grids.laboratory'),
                field: 'laboratory.labName',
                exportType: AgGridExportType.TEXT,
                minWidth: 200,
                flex: 1,
                suppressSizeToFit: true,
                filter: false,
                sortable: false
            }
        ]
    }

    public async paginator(filterModel: CommonFilterModel, params: CommonParams, scrollId: string): Promise<InfinitePaginatorResponse<StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent>> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisIncidentsDossierExternalInfo
        const typeCase = (sidebarFilter?.typeSearch as StatisticalAnalysisSidebarItemCombo[]).map((item: StatisticalAnalysisSidebarItemCombo) => item.id) as StatiscalAnalysisTypeCases[]
        const baseRequest: StatisticalAnalysisIncidentsStatisticsDossierBaseRequest = incidentsStatisticsDossierService.getBaseRequest(sidebarFilter)
        const state = sidebarFilter.trackingGeneralSelected?.key as StatisticalAnalysisIncidentTypes
        const infoType = sidebarFilter?.typeTimeFilter.id
        const groupingParams: StatisticalAnalysisDynamicObject = chain(this.row)
            .omitBy((_value: unknown, key: string) => key.startsWith('stats'))
            .omitBy((value: unknown) => value === null)
            .reduce((aggr: StatisticalAnalysisDynamicObject, value: unknown) => {
                return parseGroupingParams(aggr, value as StatisticalAnalysisViewDetailTableGroupingColumns)
            }, {})
            .value()
        const response: StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTable = await incidentsStatisticsDossierService.getExternalViewDetailList(
            filterModel,
            params,
            groupingParams,
            typeCase,
            baseRequest,
            state,
            infoType,
            scrollId,
            this.getTotalElements()
        )
        if (isNil(this.getTotalElements())) {
            this.setTotalElements(response.scrollPage.totalElements)
        }
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response.scrollPage.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getLabAndCaseId(selectedRow: StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent): [number, Nullable<number>] {
        const labId = selectedRow.laboratory.labId
        return [labId, null]
    }
}
